import Product from '~/js/models/product'

export default class FavoriteProduct extends Product {
  constructor(product = {}, variant = undefined) {
    super(Product.normalizeFavoriteProduct(product, variant))
  }
}
